import { apiFetch } from './utils/api';

// import mock from './mocks/v3/investment-strategy-cost.json';

export const investmentStrategyCosts = {
  /**
   * @desc Get a investment strategy's sosts
   *
   * @return json - data or error message
   */
  get: async (args = {}) => {
    const options = {
      method: 'GET',
    };

    if (!args.strategyId) {
      throw new Error('Strategy ID required for this API endpoint');
    }

    const url = `/v3/investment-strategies/${args.strategyId}/costs`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
